<div class="seamless-transitions-page">
    <app-pillar-pages-temp></app-pillar-pages-temp>
</div>
